import React, { useEffect, useMemo, useState } from "react";
import { getFileUrl } from "../../../api";

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];
const PDF_EXTENSIONS = ["pdf"];

const getExtension = (name = "") => {
 const cleanName = name.split("?")[0].split("#")[0];
 return cleanName.includes(".") ? cleanName.split(".").pop().toLowerCase() : "";
};

const isImageDocument = ({ file, fileName, fileUrl }) => {
 if (file?.type?.startsWith("image/")) return true;
 return IMAGE_EXTENSIONS.includes(getExtension(fileName || fileUrl || file?.name || ""));
};

const isPdfDocument = ({ file, fileName, fileUrl }) => {
 if (file?.type === "application/pdf") return true;
 return PDF_EXTENSIONS.includes(getExtension(fileName || fileUrl || file?.name || ""));
};

const WirDocumentPreview = ({ doc }) => {
 const file = doc?.file;
 const fileName = doc?.fileName || file?.name || "Document";
 const fileUrl = doc?.fileUrl || doc?.url || "";
 const isLocalFile = file instanceof File;
 const isImage = isImageDocument({ file, fileName, fileUrl });
 const isPdf = isPdfDocument({ file, fileName, fileUrl });
 const [imageFailed, setImageFailed] = useState(false);

 const previewUrl = useMemo(() => {
 if (isLocalFile) return URL.createObjectURL(file);
 return getFileUrl(fileUrl);
 }, [file, fileUrl, isLocalFile]);

 useEffect(() => {
 return () => {
 if (isLocalFile && previewUrl) URL.revokeObjectURL(previewUrl);
 };
 }, [isLocalFile, previewUrl]);

 useEffect(() => {
 setImageFailed(false);
 }, [previewUrl]);

 if (!previewUrl) return <span>{fileName}</span>;

 return (
 <div className="d-flex flex-column align-items-start gap-1">
 <a href={previewUrl} target="_blank" rel="noopener noreferrer">
 {fileName}
 </a>
 {isLocalFile && (
 <small className="text-muted">Preview before upload</small>
 )}
 {isImage && !imageFailed && (
 <a href={previewUrl} target="_blank" rel="noopener noreferrer">
 <img
 src={previewUrl}
 alt={fileName}
 className="border rounded"
 onError={() => setImageFailed(true)}
 style={{
 width: "120px",
 height: "80px",
 objectFit: "cover",
 background: "#f8f9fa",
 }}
 />
 </a>
 )}
 {!isImage && isPdf && (
 <a href={previewUrl} target="_blank" rel="noopener noreferrer">
 <iframe
 src={previewUrl}
 title={fileName}
 className="border rounded"
 style={{
 width: "120px",
 height: "90px",
 background: "#f8f9fa",
 pointerEvents: "none",
 }}
 />
 </a>
 )}
 {((isImage && imageFailed) || (!isImage && !isPdf)) && (
 <a
 href={previewUrl}
 target="_blank"
 rel="noopener noreferrer"
 className="border rounded d-flex align-items-center justify-content-center text-center text-muted"
 style={{
 width: "120px",
 height: "80px",
 background: "#f8f9fa",
 fontSize: "12px",
 padding: "8px",
 }}
 >
 Open file
 </a>
 )}
 </div>
 );
};

export default WirDocumentPreview;
